import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import DeenDistrict from "@/pages/DeenDistrict";
import Admin from "@/pages/Admin";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import About from "@/pages/About";
import Shop from "@/pages/Shop";
import Contact from "@/pages/Contact";
import TrackOrder from "@/pages/TrackOrder";
import Cart from "@/pages/Cart";
import Wholesale from "@/pages/Wholesale";
import Ambassadors from "@/pages/Ambassadors";
import AmbassadorAuth from "@/pages/AmbassadorAuth";
import AmbassadorDashboard from "@/pages/AmbassadorDashboard";
import { RefCapture } from "@/components/ambassadors/RefCapture";
import { CartProvider } from "@/components/landing/cart/CartContext";
import { CartDrawer } from "@/components/landing/cart/CartDrawer";
import { PayPalProvider } from "@/components/landing/cart/PayPalButton";
import { ScrollToTop } from "@/components/ScrollToTop";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain">
      <BrowserRouter>
        <CartProvider>
        <PayPalProvider>
        <ScrollToTop />
        <RefCapture />
        <Routes>
          <Route path="/" element={<DeenDistrict />} />
          <Route path="/ambassadors" element={<Ambassadors />} />
          <Route path="/ambassadors/dashboard" element={<AmbassadorDashboard />} />
          <Route path="/ambassadors/:mode" element={<AmbassadorAuth />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/track-order" element={<TrackOrder />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shop/:category" element={<Shop />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/wholesale" element={<Wholesale />} />
        </Routes>
        <CartDrawer />
        </PayPalProvider>
        </CartProvider>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="light"
        toastOptions={{
          style: {
            background: "#ffffff",
            border: "1px solid #e3e2dc",
            color: "#0a0a0b",
          },
        }}
      />
    </div>
  );
}

export default App;
